// @generated by protoc-gen-es v1.3.0
// @generated from file admin/v1/types/v1/domain.proto (package admin.v1.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message admin.v1.types.v1.Domain
 */
export const Domain = proto3.makeMessageType(
  "admin.v1.types.v1.Domain",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owners", kind: "message", T: Owner, repeated: true },
    { no: 5, name: "excluded_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "included_paths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message admin.v1.types.v1.Owner
 */
export const Owner = proto3.makeMessageType(
  "admin.v1.types.v1.Owner",
  () => [
    { no: 1, name: "object_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "object_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

